import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelpIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.0587 5.99967C6.21543 5.55412 6.5248 5.17841 6.932 4.9391C7.3392 4.69978 7.81796 4.6123 8.28348 4.69215C8.749 4.772 9.17124 5.01402 9.47542 5.37536C9.77959 5.7367 9.94607 6.19402 9.94536 6.66634C9.94536 7.99967 7.94536 8.66634 7.94536 8.66634M7.9987 11.333H8.00536M14.6654 7.99967C14.6654 11.6816 11.6806 14.6663 7.9987 14.6663C4.3168 14.6663 1.33203 11.6816 1.33203 7.99967C1.33203 4.31778 4.3168 1.33301 7.9987 1.33301C11.6806 1.33301 14.6654 4.31778 14.6654 7.99967Z",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHelpIcon;
